import { seoFields } from './seoFields'

export const fitmentGuideSeoGroup = {
  name: 'fitmentGuideSEO',
  title: 'Fitment Guide SEO data',
}

export default ({ path = '' } = {}) => ({
  title: 'Fitment Guide Page Info',
  name: 'fitmentGuidePageInfo',
  type: 'object',
  group: 'fitmentGuideSEO',
  fields: [...seoFields],
})
